import React from "react";
import { noop } from "lodash/fp";

import Button from "../../_atom/Buttons/button";
import Text from "../../_atom/Text";
import buildColor from "../../_static/ColorPalette";
import {
  BodyElement,
  StyledTitle,
  ButtonsContainer,
  IconContainer,
  OuterContainer,
  InnerContainer,
  TextBelowButtons
} from "./styled-components";
import Icon from "../../_static/Icons";
import {
  america,
  exclamationMark,
  infoOutline
} from "../../_static/Icons/iconsDuotone";
import KycOnfido from "../../_static/SvgImages/KycOnfido";
import OnfidoChecks from "../../_static/SvgImages/OnfidoCheck";
import { fontNormal } from "../../_static/Typography";
import OnfidoCheckError from "../../_static/SvgImages/OnfidoCheckError";
import HeaderRegistration from "../../_organism/HeaderRegistration";

const icons = {
  ageError: (
    <Icon
      size={62}
      icon={exclamationMark}
      filter="drop-shadow(0px 2px 4px rgba(17, 43, 68, 0.18))"
      viewBoxSize={16}
      strokeColorList={[null, buildColor("blue_accent", "600")]}
      strokeWidthList={[null, 1]}
      color={buildColor("blue_accent", "300")}
    />
  ),
  invalidWageringState: (
    <IconContainer>
      <Icon
        size={42}
        icon={exclamationMark}
        filter="drop-shadow(0px 2px 4px rgba(17, 43, 68, 0.18))"
        viewBoxSize={16}
        strokeColorList={[null, buildColor("yellow", "700")]}
        strokeWidthList={[null, 1.2]}
        color={buildColor("yellow", "200")}
      />
      <Icon
        size={120}
        icon={america}
        viewBoxSize={120}
        strokeColorList={[buildColor("blue", "300"), buildColor("blue", "100")]}
        strokeWidthList={[2.5]}
      />
    </IconContainer>
  ),
  brandError: (
    <IconContainer>
      <Icon
        size={42}
        icon={exclamationMark}
        filter="drop-shadow(0px 2px 4px rgba(17, 43, 68, 0.18))"
        viewBoxSize={16}
        strokeColorList={[null, buildColor("yellow", "700")]}
        strokeWidthList={[null, 1.2]}
        color={buildColor("yellow", "200")}
      />
      <Icon
        size={120}
        icon={america}
        viewBoxSize={120}
        strokeColorList={[buildColor("blue", "300"), buildColor("blue", "100")]}
        strokeWidthList={[2.5]}
      />
    </IconContainer>
  ),
  onfidoError: <KycOnfido />,
  onfidoChecks: <OnfidoChecks />,
  onfidoChecksError: <OnfidoCheckError />,
  onfidoChecksErrorWithChat: <OnfidoCheckError />,
  failCreateAccount: (
    <Icon
      size={62}
      icon={exclamationMark}
      viewBoxSize={16}
      strokeColorList={[null, buildColor("blue_accent", "600")]}
      strokeWidthList={[null, 1]}
      color={buildColor("blue_accent", "300")}
    />
  )
};

const defaultIcon = (
  <Icon
    size={56}
    icon={infoOutline}
    colorList={[
      buildColor("blue_accent", "300"),
      buildColor("blue_accent", "600")
    ]}
  />
);

const InfoScreen = ({
  icon,
  bodyContent,
  buttonTextSuccess,
  buttonTextSecondary,
  buttonTextClose,
  onClickSuccess,
  onClickSecondary,
  onClickClose,
  textBelowButtons,
  isOnfidoChecks,
  showDelayedText,
  device,
  brand
}) => {
  return (
    <OuterContainer data-qa-label={`error-${icon}-outer-container`}>
      <HeaderRegistration device={device} brand={brand} isWelcomePage />
      <InnerContainer
        data-qa-label={`error-${icon}-inner-container`}
        isOnfidoChecks={isOnfidoChecks}
      >
        {icons[icon] || defaultIcon}
        {bodyContent.map(({ title, text }, index) => (
          <BodyElement
            lastChild={bodyContent.length - 1 === index}
            // eslint-disable-next-line react/no-array-index-key
            key={`${index}${title}`}
          >
            {title && <StyledTitle>{title}</StyledTitle>}
            <Text lineHeight="20px">{text}</Text>
          </BodyElement>
        ))}
        <ButtonsContainer>
          {buttonTextSuccess && onClickSuccess && (
            <Button
              onClick={onClickSuccess}
              size="bigger"
              isUppercase={false}
              hasRoundedCorners
              isStretched
              hasShadow
              fontFamily={fontNormal}
              qaLabel="registration-submit-btn"
              isLoading={isOnfidoChecks}
              loadingBackgroundColor={buildColor("white", "100")}
              loadingBorderColor={buildColor("white", "30")}
            >
              {buttonTextSuccess}
            </Button>
          )}
          {buttonTextSecondary && onClickSecondary && (
            <Button
              onClick={onClickSecondary}
              type="secondary"
              size="bigger"
              isUppercase={false}
              qaLabel="registration-secondary-btn"
            >
              {buttonTextSecondary}
            </Button>
          )}
          {buttonTextClose && (
            <Button
              onClick={onClickClose}
              type="tertiary"
              size="bigger"
              isUppercase={false}
              qaLabel="registration-tertiary-btn"
            >
              {buttonTextClose}
            </Button>
          )}
          {showDelayedText && textBelowButtons && (
            <TextBelowButtons>{textBelowButtons}</TextBelowButtons>
          )}
        </ButtonsContainer>
      </InnerContainer>
    </OuterContainer>
  );
};

InfoScreen.defaultProps = {
  icon: "",
  bodyContent: [{ title: "", text: "" }],
  buttonTextSuccess: "",
  buttonTextSecondary: "",
  buttonTextClose: "",
  onClickSuccess: noop,
  onClickSecondary: noop,
  onClickClose: noop,
  isOnfidoChecks: false,
  textBelowButtons: "",
  showDelayedText: false
};

export default InfoScreen;
